var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasErrors)?_c('div',[_c('div',{staticClass:"font-medium text-red-600"},[_vm._v("Whoops! Something went wrong.")]),_vm._v(" "),_c('ul',{staticClass:"mt-3 list-disc list-inside text-sm text-red-600"},_vm._l((_vm.errors),function(error,key){return _c('li',{key:key},[_vm._v(_vm._s(error))])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }